interface MobileEmptyProps {
  message: string;
}

export function MobileEmpty({ message }: MobileEmptyProps) {
  return <div className="mobile-empty">{message}</div>;
}
